class ComponentProductCard extends HTMLElement {
  constructor() {
    super()
    this.quickViewBtn = this.querySelector('.quick-view-trigger')
    this.swatches = this.querySelector('.swatch-group')

    if(this.quickViewBtn)
      this.quickViewBtn.addEventListener('click', this.openQuickView.bind(this))
    if(this.swatches)
      this.swatches.querySelectorAll('input').forEach((input)=>{
        input.addEventListener('change', this.onSwatchChange.bind(this))
      })
    
    this.replaceTextReview(this.querySelectorAll('product-card .okeReviews-reviewsSummary-ratingCount span[aria-hidden=true]'));    

  }

  openQuickView(e) {
    e.preventDefault()
    $s.showLoadingOverlay();
    $s.getJson({
      url: this.quickViewBtn.dataset.url,
      success: (data)=>{
        $s.openModal(data['main_product'], 'product-quick-view');
        $s.globalEval(data["main_product"]);
      },
      always: (data)=>{
        $s.hideLoadingOverlay();
      }
    })
  }

  onSwatchChange() {
    var checkedOption = this.querySelector('input:checked')
    var variantImg = checkedOption.dataset.variantImg
    var variantUrl = checkedOption.dataset.variantUrl
    var priceFinal = checkedOption.dataset.priceFinal
    var priceCompare = checkedOption.dataset.priceCompare

    this.querySelector('.product-card-url').setAttribute('href', variantUrl)
    this.querySelector('.quick-view-trigger').setAttribute('data-url', variantUrl)
    this.querySelector('.final').innerHTML = priceFinal
    if(this.querySelector('.from')) {
      this.querySelector('.from').style.display = "none"
    }
    if(priceCompare) {
      this.querySelector('.compare').innerHTML = priceCompare
      this.querySelector('.compare').style.display = "block"
    } else {
      this.querySelector('.compare').style.display = "none"
    }
    if(variantImg) {
      this.querySelector('.img.main').setAttribute('srcset', variantImg)
    }
  }

  replaceTextReview(text){
    text.forEach((t) => {
      let modifiedText = (t.textContent).replace(' Review', '').replace('s', '').replace('(', '').replace(')', '');
      setTimeout(() => {
        t.textContent = '(' + modifiedText + ')';
      }, 1);         
    })        
  }
}
customElements.define('product-card', ComponentProductCard);

class ComponentCardSelector extends ComponentProductCard {
  constructor() {
    super()
    this.planSelector = this.querySelector('[data-plan-selector]') ? this.querySelector('[data-plan-selector]') : false
    this.variantSelector = this.querySelector('[data-variant-selector]') ? this.querySelector('[data-variant-selector]') : false
    this.buttonSelector = this.querySelector('[data-button-selector]') ? this.querySelector('[data-button-selector]') : false
    this.product = JSON.parse(this.querySelector('.product-json [type="application/json"]').textContent)
    this.productJSON = this.querySelector('.product-json [type="application/json"]').textContent
    this.variantSelected = {id: this.product.variants[0].id, selling_plan: ''};
    this.toogleButton = this.parentNode.querySelector('.choose-options');
    this.closeButton = this.querySelector('.close-options');
    this.closeButtonSVG = this.closeButton.firstChild;
    this.firstLoad = true;
    var self = this;

    if (this.variantSelector) {
      this.variantInputs = this.variantSelector.querySelectorAll('label > input')
      this.shadeInputs = this.querySelectorAll('.option-group-name.shade label > input')
      this.sizeInputs = this.querySelectorAll('.option-group-name.size label > input')

      this.variantInputs.forEach((input) => {     
        this.variantSelect(this);
        input.addEventListener('change', (e)=>{
          e.preventDefault();
          self.variantSelect(self);
        })
      }) 

      this.sizeInputs.forEach((input) => {     
        this.variantSelect(this);
        input.addEventListener('change', (e)=>{
          e.preventDefault();
          self.checkSizesExtra(self)
        })
      }) 

      this.shadeInputs.forEach((input) => {     
        this.variantSelect(this);
        input.addEventListener('change', (e)=>{
          e.preventDefault();
          self.checkSizes(self)
        })
      }) 
      
    }

    if (this.planSelector) {
      this.planInputs = this.planSelector.querySelectorAll('label > input')
      this.planLabels = this.planSelector.querySelectorAll('label')

      this.planInputChecked = this.planSelector.querySelector('label > [checked]')
      

      this.planLabels.forEach((label) => {     
        label.addEventListener("keypress", function(event) {
          if (event.key === "Enter") {
            event.preventDefault();
            this.querySelector('input').click();
          }
        });
      })   

      this.planInputs.forEach((input) => {
        if (input.checked ) {
          self.variantSelected.selling_plan = input.value;
        }        
        input.addEventListener('change', (e)=>{
          e.preventDefault();          
          self.variantSelected.selling_plan = e.target.value;
          this.planInputChecked.removeAttribute('checked')
        })
      })
    }

    if (this.buttonSelector) {
      this.allTheInputs = this.querySelectorAll('[type="radio"]')
      this.submitButton = this.buttonSelector.querySelector('[type="submit"]');
      this.bisButton = this.buttonSelector.querySelector('.BIS_trigger');
      setTimeout(function(){        
        self.buttonsUpdate(self)
      }, 100);
      this.allTheInputs.forEach((input, i) => {      
        input.addEventListener('change', (e)=>{
          e.preventDefault();
          setTimeout(function(){        
            self.buttonsUpdate(self)
          }, 100);
        })
      })
      this.buttonSelector.querySelector('[type="submit"]').addEventListener('click', (e) => {
        e.preventDefault();
        this.productAdd(this.variantSelected);
      })
    }

    if (this.toogleButton) {      
      this.toogleButton.addEventListener('click', (e) => {
        self.closeButtonSVG.style.opacity = '1';
        $s.toggle([e.target.previousElementSibling]);
        $s.trapFocus(this);
      }) 
      this.toogleButton.querySelector('span').addEventListener('click', (e) => {
        self.closeButtonSVG.style.opacity = '1';
        $s.toggle([e.target.parentNode.previousElementSibling]);
        $s.trapFocus(this);
      }) 
      this.toogleButton.querySelector('.sub-price').addEventListener('click', (e) => {
        self.closeButtonSVG.style.opacity = '1';
        $s.toggle([e.target.parentNode.previousElementSibling]);
        $s.trapFocus(this);
      })          
    }

    if (this.closeButton) {      
      this.closeButton.addEventListener('click', (e) => {        
        self.closeButtonSVG.style.opacity = '0'; 
        this.toogleButton.querySelector('span').style.visibility = "visible";
        this.toogleButton.querySelector('span').style.maxHeight = "100%";
        $s.toggle([self]);             
      })      
    }
    
  }

  checkSizes(theThis){
    var self = theThis;  
    var swatch = '';
    if(self.querySelector('.option-group-name.shade input:checked')){
      swatch = self.querySelector('.option-group-name.shade input:checked').value;
    }  
    var availableOptions = []

    self.product.variants.forEach((variant) => {
      if(variant.options.includes(swatch)){
        variant.options.forEach((variantName) => {
          if(!availableOptions.includes(variantName)){
            availableOptions.push(variantName)
          }
        })
        self.querySelectorAll('.option-group-name.size input').forEach((element)=>{
          if(!availableOptions.includes(element.value)){
            element.parentNode.classList.add('hide')
            if(element.parentNode.classList.contains('enabled')){
              element.parentNode.classList.remove('enabled');
            }
          }else{
            if(element.parentNode.classList.contains('hide')){
              element.parentNode.classList.remove('hide');
            }
            if(!element.parentNode.classList.contains('enabled')){
              element.parentNode.classList.add('enabled');
            }
          }
        }) 
        if(self.querySelector('.option-group-name.size label.enabled')){
          self.querySelector('.option-group-name.size label.enabled').click()
        }
      }
    })   

  }

  checkSizesExtra(theThis){
    var self = theThis;  
    var availableOptions = []
    var size = '';
    if(self.querySelector('.option-group-name.size input:checked')){
      size = self.querySelector('.option-group-name.size input:checked').value;
    }  
    self.product.variants.forEach((variant) => {
      if(variant.options.includes(size)){
        variant.options.forEach((variantName) => {
          if(!availableOptions.includes(variantName)){
            availableOptions.push(variantName)
          }
        })
        self.querySelectorAll('.option-group-name.shade input').forEach((element)=>{
          if(!availableOptions.includes(element.value)){
            element.parentNode.classList.add('hide')
            if(element.parentNode.classList.contains('enabled')){
              element.parentNode.classList.remove('enabled');
            }
          }else{
            if(element.parentNode.classList.contains('hide')){
              element.parentNode.classList.remove('hide');
            }
            if(!element.parentNode.classList.contains('enabled')){
              element.parentNode.classList.add('enabled');
            }
          }
        }) 
        if(self.querySelector('.option-group-name.shade label.enabled')){
          self.querySelector('.option-group-name.shade label.enabled').click()
        }
      }
    })

  }


  variantSelect(theThis){
    var self = theThis;    
    self.setValues = '';
    self.setSelectorValues = [];

    var img = self.parentElement.querySelector('.img.main');

    var allGroups = self.variantSelector.querySelectorAll('.option-group-name')
    allGroups.forEach((group, i) => {
      if(!group.querySelector('label > input:checked')){
        var checkedInput = group.querySelector('[checked]')
        checkedInput.click()
      }
    })
    var allInputs = self.variantSelector.querySelectorAll('label > input:checked')
    var oldinputs = self.variantSelector.querySelectorAll('.checked')
    oldinputs.forEach((input) => {
      input.classList.remove('checked');
    })   
    allInputs.forEach((input) => {
      input.parentElement.classList.add('checked');
      self.setValues += `${input.value} / `;
      self.setSelectorValues.push(input.value);
    })   
    
    self.setValues = self.setValues.slice(0, -3)
    self.setValues = self.setValues.trim()
    
    self.product.variants.forEach((variant) => {
      if(variant.title === self.setValues){
        if(variant.selling_plan_allocations.length == 0){
          self.querySelector('.one-timer').click();
          self.querySelector('.subscriptions-wrapper').style.display = "none"
        }else{
          self.querySelector('.subscriptions-wrapper').style.display = "block"
        }
        self.variantSelected.id = variant.id
        self.buttonSelector.querySelector('.BIS_trigger').setAttribute(`data-variant-id`,`pepoi`)
        if(variant.featured_image){
          img.srcset = variant.featured_image.src
        }
      } 
    })   
  }

  buttonsUpdate(theThis){
    var self = theThis;
    var cardPrice = self.parentNode.parentNode.querySelector('.info .price')
    self.product.variants.forEach((variant) => {
      if (variant.id == self.variantSelected.id){
        if (variant.available) {
          self.submitButton.disabled = false;
          self.submitButton.style.display = 'block';
          self.bisButton.disabled = true;
          self.bisButton.style.display = 'none';
          self.submitButton.style.opacity = '1';
          if (self.variantSelected.selling_plan && variant.selling_plan_allocations[0].price_adjustments[0].price) {
            self.sellingPlanPrice = '$ '+(((variant.selling_plan_allocations[0].price_adjustments[0].price) / 100).toFixed(2))

            if (self.sellingPlanPrice.includes('.00')) {
              self.sellingPlanPrice = self.sellingPlanPrice.slice(0, -3)
            }
            self.submitButton.innerHTML = `Add <span class="small--hide">to bag </span>- ${ variant.compare_at_price ? '<span class="retail">$'+ ((((variant.compare_at_price) / 100).toFixed(2).toString().replace('.00',''))) +'</span>': ''} ${self.sellingPlanPrice}`
            //cardPrice.innerHTML = `${self.sellingPlanPrice}`
          } else {
            // var currentInput = self.querySelector('[data-variant-selector] [checked]')
            // if(self.firstLoad && currentInput){
            //   currentInput.click();
            //   self.firstLoad = false
            // }
            self.defaultPrice = '$ '+(((variant.price) / 100).toFixed(2))
            if (self.defaultPrice.includes('.00')) {
              self.defaultPrice = self.defaultPrice.slice(0, -3)
            }
            self.submitButton.innerHTML = `Add <span class="small--hide">to bag </span>- ${ variant.compare_at_price ? '<span class="retail">$'+ ((((variant.compare_at_price) / 100).toFixed(2).toString().replace('.00',''))) +'</span>': ''} ${self.defaultPrice}`
            //cardPrice.innerHTML = `${self.defaultPrice}`
          }
        } else {
          self.submitButton.disabled = true;
          self.submitButton.style.display = 'none';
          self.bisButton.style.display = 'block';        
          setTimeout(() => {
            self.bisButton.disabled = false;
            self.bisButton.textContent = 'Notify me when available';             
          }, 2000);
            
        }    
      }
    })
  }


  productAdd(variant){ 
    $s.showLoadingOverlay();
    $s.post({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        "items": [
          {
           "id": `${variant.id}`,
           "quantity": "1",
           "selling_plan" : `${variant.selling_plan}`
          }
        ]
      },
      dataType: 'json',
      success: function (data) {
          $s.addToCartSuccess();
          $s.hideLoadingOverlay();
      }
    });
  }

}
customElements.define('card-selector', ComponentCardSelector);